export default {"src":"/pro/_next/static/media/pengu.6549bede.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};